import React from "react";
import { BqnCell } from "../../BqnCell";

const doesNothing = () => {};

const DeleteIPRangeButton = ({ onClick = doesNothing }) => (
  <a className="action waves-effect borderless" onClick={onClick}>
    <i className="material-icons">delete</i>
  </a>
);

const IPRangeItem = ({
  id,
  address = "",
  deleted,
  even = false,
  onDelete = doesNothing,
  showBqn = false,
  bqns,
}) => {
  if (deleted === true) {
    return null;
  }
  const doIPRangeDelete = () => {
    onDelete(id);
  };

  const onClick = () => {
    if (showBqn) {
      showModalConfirm(
        "Remove address for all BQN's?",
        "The address will be removed for all BQN's in the cluster when Applied, please use the other tabs if you want to remove just for specific BQNs.",
        "warning",
        () => doIPRangeDelete(),
        () => null,
        "OK",
        "CANCEL",
      );
    } else {
      doIPRangeDelete();
    }
  };

  return (
    <React.Fragment>
      <tr className={`${even ? "even" : "odd"}`}>
        {showBqn && <BqnCell bqns={bqns} />}
        <td>{address}</td>
        <td className="text-center hides-content-to-operators">
          <DeleteIPRangeButton onClick={onClick} />
        </td>
      </tr>
    </React.Fragment>
  );
};
const IPRangesList = ({
  items = [],
  onDelete = doesNothing,
  onEdit = doesNothing,
  bqn,
  metadata,
}) => (
  <table className="table">
    <thead>
      <tr>
        {bqn === "all" ? <th>BQN</th> : null}
        <th>IP ADDRESSES TO BYPASS</th>
        <th className="text-center">ACTIONS</th>
      </tr>
    </thead>
    <tbody>
      {items
        .filter(({ deleted }) => deleted !== true)
        .map(({ __id, ...client }, index) => (
          <IPRangeItem
            id={__id}
            key={__id}
            {...client}
            even={(index + 1) % 2 === 0}
            onDelete={() => onDelete(__id)}
            onEdit={() => onEdit(__id)}
            showBqn={bqn === "all"}
            bqns={metadata?.ipRanges[client.address]}
          />
        ))}
    </tbody>
  </table>
);
export default IPRangesList;
